var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0594 13.059C22.6453 12.473 22.6453 11.5215 22.0594 10.9355L14.5594 3.43555C13.9734 2.84961 13.0219 2.84961 12.4359 3.43555C11.85 4.02148 11.85 4.97305 12.4359 5.55898L17.3812 10.4996H3C2.17031 10.4996 1.5 11.1699 1.5 11.9996C1.5 12.8293 2.17031 13.4996 3 13.4996H17.3766L12.4406 18.4402C11.8547 19.0262 11.8547 19.9777 12.4406 20.5637C13.0266 21.1496 13.9781 21.1496 14.5641 20.5637L22.0641 13.0637L22.0594 13.059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhite);
export default __webpack_public_path__ + "static/media/rightArrowWhite.b57adb43252f8e2fc8a3d49431d4bbc1.svg";
export { ForwardRef as ReactComponent };